export default {
  props: {
    title: String,
    icon: String,
    leftBtns: {
      type: Array,
      default: () => [],
    },
    rightBtns: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    title() {},
  },
};
